import { render } from "./EditVatRateModal.vue?vue&type=template&id=03978d62&scoped=true"
import script from "./EditVatRateModal.vue?vue&type=script&lang=js"
export * from "./EditVatRateModal.vue?vue&type=script&lang=js"

import "./EditVatRateModal.vue?vue&type=style&index=0&id=03978d62&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03978d62"]])

export default __exports__